import React from 'react';
import { Loader2, CheckCircle2, XCircle, Clock } from 'lucide-react';
import { useTaskPolling } from './useTaskPolling';

interface TriggerTaskProgressProps {
  sessionId?: string;
  workflowId: string;
  executionId: string;
  label: string;
  onViewDetail?: (workflowId: string, executionId: string) => void;
}

export function TriggerTaskProgress({ sessionId, workflowId, executionId, label, onViewDetail }: TriggerTaskProgressProps) {
  const { task, loading, timedOut } = useTaskPolling(sessionId, workflowId, executionId);

  const status = timedOut ? 'timed_out' : (task?.status || (loading ? 'running' : 'unknown'));

  const chip = (() => {
    switch (status) {
      case 'running':
        return { icon: <Loader2 size={11} className="animate-spin" />, text: 'Running', className: 'border-blue-200 text-blue-600 bg-blue-50/50' };
      case 'completed':
        return { icon: <CheckCircle2 size={11} />, text: 'Completed', className: 'border-green-200 text-green-600 bg-green-50/50' };
      case 'failed':
        return { icon: <XCircle size={11} />, text: 'Failed', className: 'border-red-200 text-red-600 bg-red-50/50' };
      case 'timed_out':
        return { icon: <Clock size={11} />, text: 'Still running — check back later', className: 'border-amber-200 text-amber-600 bg-amber-50/50' };
      default:
        return { icon: <Clock size={11} />, text: 'Pending', className: 'border-slate-200 text-slate-400 bg-slate-50' };
    }
  })();

  return (
    <div className="flex items-center gap-1.5 mt-2">
      <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-lg text-[11px] font-semibold border ${chip.className}`}>
        {chip.icon} {label}: {chip.text}
      </span>
      {onViewDetail && (
        <button
          type="button"
          onClick={() => onViewDetail(workflowId, executionId)}
          className="text-[11px] font-semibold text-primary hover:underline"
        >
          View details
        </button>
      )}
    </div>
  );
}
